import { Box, Divider, useField } from "@strapi/design-system";
import { Typography } from "@strapi/design-system/Typography";
import { Radio, Space } from "antd";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import UploadFile from "../uploadFile";

const ProofAttachmentTab = ({
  dataForUpdate,
  setDataForUpdate,
  isSecretariatView = false,
}) => {
  const { t } = useTranslation();
  const [fileList, setFileList] = useState([]);
  const [fileList1, setFileList1] = useState([]);
  const [selectedRequiredAttachment, setSelectedRequiredAttachment] = useState(null);


  useEffect(() => {
    if (dataForUpdate?.type_proof) {
      const item = documentOfOrigin.find(
        (x) => x.key === dataForUpdate?.type_proof
      );
      setSelectedDocumentOfOrigin(item);
    }
  }, [dataForUpdate?.type_proof]);

  useEffect(() => {
    if (dataForUpdate?.proof_attachment) {
      let tmp = [];
      let uploadedImages = [];
      if (localStorage.getItem("uploaded_images")) {
        uploadedImages = JSON.parse(localStorage.getItem("uploaded_images"));
      }

      dataForUpdate?.proof_attachment?.forEach((element) => {
        if (element?.id) {
          tmp.push({
            uid: element?.id,
            name: element?.name || "New File",
            url: element?.url,
            status: "done",
          });
        } else {
          if (uploadedImages.length > 0) {
            const img = uploadedImages.find((x) => x.id === element);

            if (img) {
              tmp.push({
                uid: img.id,
                name: img.name,
                url: img.url,
                status: "done",
              });
            } else {
              tmp.push({
                uid: element,
                name: "New File",
                url: "",
                status: "done",
              });
            }
          } else {
            tmp.push({
              uid: element,
              name: "New File",
              url: "",
              status: "done",
            });
          }
        }
      });
      setFileList([...tmp]);
    } else {
      setFileList([]);
    }
  }, [dataForUpdate?.proof_attachment]);

  useEffect(() => {
    if (dataForUpdate?.identifier_attachment) {
      let tmp = [];
      let uploadedImages = [];
      if (localStorage.getItem("uploaded_images")) {
        uploadedImages = JSON.parse(localStorage.getItem("uploaded_images"));
      }

      dataForUpdate?.identifier_attachment?.forEach((element) => {
        if (element?.id) {
          tmp.push({
            uid: element?.id,
            name: element?.name || "New File",
            url: element?.url,
            status: "done",
          });
        } else {
          if (uploadedImages.length > 0) {
            const img = uploadedImages.find((x) => x.id === element);

            if (img) {
              tmp.push({
                uid: img.id,
                name: img.name,
                url: img.url,
                status: "done",
              });
            } else {
              tmp.push({
                uid: element,
                name: "New File",
                url: "",
                status: "done",
              });
            }
          } else {
            tmp.push({
              uid: element,
              name: "New File",
              url: "",
              status: "done",
            });
          }
        }
      });

      setFileList1([...tmp]);
    } else {
      setFileList1([]);
    }
  }, [dataForUpdate?.identifier_attachment]);

  useEffect(() => {
    if (dataForUpdate?.selected_required_attachment) {
      setSelectedRequiredAttachment(dataForUpdate.selected_required_attachment);
    }
  }, [dataForUpdate?.selected_required_attachment]);

  const documentOfOrigin = [
    {
      key: "vn",
      name: `${t("str_vietnamese_citizen")}`,
      title: `${t("str_for_vietnamese_citizen")}`,
      description: `${t("str_vietnamese_citizen_note")}`,
      attachments: [
        {
          key: "cmnd",
          value: `${t("str_identity_card")}`,
        },
        {
          key: "cccd",
          value: `${t("str_citizen_id")}`,
        },
        {
          key: "passport",
          value: `${t("str_passport")}`,
        },
      ],
    },
    {
      key: "vn_external",
      name: `${t("str_settle_abroad")}`,
      title: `${t("str_for_settle_abroad")}`,
      description: `${t("str_vietnamese_settle_note")}`,
      attachments: [
        {
          key: "passport",
          value: `${t("str_valid_vietnamese_passport")}`,
        },
        {
          key: "giayxacnhan",
          value: `${t("str_certificate_embassy")}`,
        },
        {
          key: "giaykhaisinh",
          value: `${t("str_birth_certificate")}`,
        },
        {
          key: "thecancuoc",
          value: `${t("str_id_card")}`,
        },
        {
          key: "cmnd",
          value: `${t("str_identity_card")}`,
        },
        {
          key: "cccd",
          value: `${t("str_citizen_id")}`,
        },
        {
          key: "sdkhokhau",
          value: `${t("str_household_book")}`,
        },
        {
          key: "giaycnkethon",
          value: `${t("str_certificate_of_marriage")}`,
        },
        {
          key: "old_passport",
          value: `${t("str_passport_old")}`,
        },
      ],
    },
    {
      key: "other",
      name: `${t("str_settle_abroad_relationship")}`,
      title: `${t("str_for_settle_abroad_relationship")}`,
      description: `${t("str_vietnamese_settle_relationship")}`,
      requiredAttachments: [
        {
          key: "birth_certificate",
          value: `${t("str_nominee_birth_certificate_relationship")}`,
        },
      ],
      attachments: [
        {
          key: "vn_origin_certificate",
          value: `${t("str_nominee_certificate_relationship_embassy")}`,
        },
        {
          key: "giaykhaisinh",
          value: `${t("str_birth_certificate_of_grandparent_or_parent")}`,
        },
        {
          key: "thecancuoc",
          value: `${t("str_identification_card_of_grandparent_or_parent")}`,
        },
        {
          key: "cmnd",
          value: `${t("str_identity_card_of_grandparent_or_parent")}`,
        },
        {
          key: "cccd",
          value: `${t("str_citizen_id_of_grandparent_or_parent")}`,
        },
        {
          key: "sdkhokhau",
          value: `${t("str_household_book_of_grandparent_or_parent")}`,
        },
        {
          key: "giaycnkethon",
          value: `${t("str_marriage_certificate_of_grandparent_or_parent")}`,
        },
        {
          key: "passport",
          value: `${t("str_expired_passpord_of_grandparent_or_parent")}`,
        },
      ],
    },
  ];

  const [selectedDocumentOfOrigin, setSelectedDocumentOfOrigin] = useState();

  const handleProofAttachmentChange = (resFile) => {
    setDataForUpdate({
      ...dataForUpdate,
      proof_attachment: [
        ...(dataForUpdate?.proof_attachment || []),
        resFile?.id,
      ],
    });
  };

  const handleIdentifierAttachmentChange = (resFile) => {
    setDataForUpdate({
      ...dataForUpdate,
      identifier_attachment: [
        ...(dataForUpdate?.identifier_attachment || []),
        resFile?.id,
      ],
    });
  };

  const handleChangeDocumentOfOrigin = (value) => {
    const item = documentOfOrigin.find((x) => x.key === value);
    setSelectedDocumentOfOrigin(item);
    setDataForUpdate({ ...dataForUpdate, type_proof: value });
  };

  const handleChangeIdentifierType = (value) => {
    setDataForUpdate({ ...dataForUpdate, identifier_type: value });
  };

  const handleRemoveProofAttachment = (id) => {
    let tmp = [...dataForUpdate?.proof_attachment];

    const index = tmp.findIndex((x) => x?.id === id || x === id);
    if (index > -1) {
      tmp.splice(index, 1);
      setDataForUpdate({ ...dataForUpdate, proof_attachment: tmp });
    }
  };

  const handleRemoveIdentifierAttachment = (id) => {
    let tmp = [...dataForUpdate?.identifier_attachment];

    const index = tmp.findIndex((x) => x?.id === id || x === id);
    if (index > -1) {
      tmp.splice(index, 1);
      setDataForUpdate({ ...dataForUpdate, identifier_attachment: tmp });
    }
  };

  const handleRequiredAttachmentChange = (value) => {
    setSelectedRequiredAttachment(value);
    setDataForUpdate({
      ...dataForUpdate,
      selected_required_attachment: value
    });
  };

  return (
    <>
      <Box padding={4} background="neutral0">
      <Typography variant="omega" fontWeight="semiBold">
        {t("str_i_am")}:
        <span style={{ color: "red", marginLeft: 4 }}>*</span>
      </Typography>
        <br />
        <Radio.Group
          onChange={(e) => handleChangeDocumentOfOrigin(e.target.value)}
          disabled={isSecretariatView}
          defaultValue={dataForUpdate?.type_proof}
          value={dataForUpdate?.type_proof}
        >
          <Space direction="vertical">
            {documentOfOrigin.map((el) => (
              <Radio value={el.key}>{el.name}</Radio>
            ))}
          </Space>
        </Radio.Group>
      </Box>

      <Divider />
      <Box padding={4} background="neutral0">
        <div>
          <Typography
            textTransform="uppercase"
            variant="epsilon"
            fontWeight="bold"
          >
            {selectedDocumentOfOrigin?.title}
            {selectedDocumentOfOrigin?.title && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </Typography>
          <br />
          <Typography variant="pi">
            {selectedDocumentOfOrigin?.description}
          </Typography>
        </div>
        <div style={{ paddingTop: "10px" }}>
          {selectedDocumentOfOrigin?.requiredAttachments?.length > 0 && (
            <>
              <Radio.Group 
                disabled={isSecretariatView}
                onChange={(e) => handleRequiredAttachmentChange(e.target.value)}
                value={dataForUpdate?.selected_required_attachment}
              >
                <Space direction="vertical">
                  {selectedDocumentOfOrigin?.requiredAttachments?.map((el) => (
                    <Radio value={el.key}>{el.value}</Radio>
                  ))}
                </Space>
              </Radio.Group>
              <br />
              {isSecretariatView && (
                <UploadFile
                  fileMimeType={[
                    "application/pdf",
                    "image/png",
                    "image/jpeg",
                  ]}
                  fileTypeAllowNames="pdf/png/jpg/jpeg"
                  // handleUploadSuccess={handleProofAttachmentChange}
                  disabled={true}
                  fileList={fileList}
                  // handleRemoveFile={handleRemoveProofAttachment}
                  accept="application/pdf, image/png, image/jpeg"
                />
              )}
              {!isSecretariatView && (
                <>
                  <Typography 
                    variant="omega" 
                    fontWeight="semiBold"
                    style={{ paddingTop: '16px', display: 'block', marginBottom: '8px' }}
                  >
                  {t("str_required_attachment")}
                  <span style={{ color: "red", marginLeft: 4 }}>*</span>
                  </Typography>
                  <span className="subnotes">{t("str_upload_pdf_image")}</span>
                  <br />
                  <UploadFile
                    fileMimeType={[
                      "application/pdf",
                      "image/png",
                      "image/jpeg",
                    ]}
                    fileTypeAllowNames="pdf/png/jpg/jpeg"
                    handleUploadSuccess={handleProofAttachmentChange}
                    fileList={fileList}
                    handleRemoveFile={handleRemoveProofAttachment}
                    accept="application/pdf, image/png, image/jpeg"

                  />
                </>
              )}
              <br />
            </>
          )}
        </div>
        <div style={{ marginTop: "10px" }}>
          <Radio.Group
            disabled={isSecretariatView}
            onChange={(e) => handleChangeIdentifierType(e.target.value)}
            defaultValue={dataForUpdate?.identifier_type}
            value={dataForUpdate?.identifier_type}
          >
            <Space direction="vertical">
              {selectedDocumentOfOrigin?.attachments?.map((el) => (
                <Radio value={el.key}>{el.value}</Radio>
              ))}
            </Space>
          </Radio.Group>

          <br />
          {isSecretariatView && (
            <>
              <span className="subnotes">{t("str_upload_pdf_image")}</span>
              <br />
              <UploadFile
                fileMimeType={["application/pdf", "image/png", "image/jpeg"]}
                fileTypeAllowNames="pdf/png/jpg/jpeg"
                // handleUploadSuccess={handleIdentifierAttachmentChange}
                fileList={fileList1}
                disabled={true}
                // handleRemoveFile={handleRemoveIdentifierAttachment}
                accept="application/pdf, image/png, image/jpeg"
              />
            </>
          )}
          {!isSecretariatView && (
            <>
            <Typography 
                variant="omega" 
                fontWeight="semiBold"
                style={{ paddingTop: '16px', display: 'block', marginBottom: '8px' }}
              >
              {t("str_required_attachment")}
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
              </Typography>
              <span className="subnotes">{t("str_upload_pdf_image")}</span>
              <br />
              <UploadFile
                fileMimeType={["application/pdf", "image/png", "image/jpeg"]}
                fileTypeAllowNames="pdf/png/jpg/jpeg"
                handleUploadSuccess={handleIdentifierAttachmentChange}
                fileList={fileList1}
                handleRemoveFile={handleRemoveIdentifierAttachment}
                accept="application/pdf, image/png, image/jpeg"
              />
            </>
          )}
        </div>
      </Box>
    </>
  );
};

export default ProofAttachmentTab;
